/**
 * Sales > Opportunities — the 5-stage opportunity kanban
 * (NEW / ACTIVE / AWAITING / WON / LOST). Per spec section 15.8 and
 * design README section 5.9.
 */

import { createFileRoute } from '@tanstack/react-router';

import { OpportunitiesBoard } from '@/components/sales/OpportunitiesBoard';

export const Route = createFileRoute('/sales/opportunities')({
  component: () => <OpportunitiesBoard />,
});
